/**
 * This is the enum for all the store name which will be their in index DB.
 */
export enum IndexDBStoreNames {
    DIRECTORY= "Directory",
  }  